import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./StylesLoginNavBar.css";
import { navigation } from "./nav";

export const LoginNavBar = ({ socialMedia = false }) => {

  const [prevScrollPos, setPrevScrollPos] = useState(navigation);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleScroll = ({ target, name }) => {

    const screenWidth = window.innerWidth;
    if (screenWidth == 320 && name == "App") {
      target = 668;
    } else if (screenWidth == 375 && name == "App") {
      target = 645;
    }
    else if (screenWidth == 425 && name == "App") {
      target = 643;
    } 
    else if (screenWidth == 768 && name == "App") {
      target = 573;
    } else if (screenWidth == 1024 && name == "App") {
      target = 540;
    } else if (screenWidth == 320 && name == "Nosotros") {
      target = 330;
    }
   else if (screenWidth == 375 && name == "Nosotros") {
    target = 320;
  }
  else if (screenWidth == 425 && name == "Nosotros") {
    target = 320;
  }
  else if (screenWidth == 768 && name == "Nosotros") {
    target = 320;
  }
  else if (screenWidth == 1024 && name == "Nosotros") {
    target = 315;
  }


    setTimeout(() => {
      const targetPercentage = target;
      // console.log("TARGET FINAL ES : ", targetPercentage);
      const windowHeight = window.innerHeight;
      const targetPosition = (windowHeight * targetPercentage) / 100;
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    }, 100);
  };

  return (
    <nav className="login-navbar" >
    <div className="login-navbar-container">
      <button
        className="login-navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#loginNavbarNav"
        aria-controls="loginNavbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span className="login-navbar-toggler-icon"></span>
      </button>
      <div className={`login-navbar-collapse ${menuOpen ? "show" : ""}`} id="loginNavbarNav">

        <ul className="login-navbar-nav">
          {navigation.map((item, index) => (
            <li className="login-nav-item" key={index}>
              <NavLink
                to={item.link}
                className={({ isActive }) =>
                    isActive ? "login-nav-link active" : "login-nav-link"
                  }
                onClick={() => handleScroll(item)}
              >
                {item.name}
              </NavLink>
            </li>
          ))}
        
        </ul>
      </div>
    </div>
  </nav>
  
  );
};
